import getCorePersonalStore from "../stores/core/core-personal-store";
import { TCorePage, TPermissionID, TPermissionName } from "../Types";

const getPagePermission = (userPage: TCorePage): TPermissionName[] => {
  switch (userPage) {
    case "CORE_LOGIN":
      return ["NO_PERMISSION_NEEDED"];
    case "ALARMS":
      return ["Alarms"];
    case "CHANGE_PASSWORD":
      return ["NO_PERMISSION_NEEDED"];
    case "APPROVAL_DATA":
      return ["Approve-Reject"];
    case "REPORTS":
      return ["Reports"];
    case "INVESTIGATION_CASES":
      return ["Investigation-Case"];
    case "USER_ADVANCED":
    case "USER_EVENTS":
    case "USER_MESSAGES":
    case "USER_PAYMENTS":
      return ["User"];
    default:
      return ["NO_PERMISSION_NEEDED"];
  }
};

export const getPermissionIDRequired = (
  userPermission: TPermissionName
): TPermissionID => {
  switch (userPermission) {
    case "Alarms":
      return 39;
    case "User":
      return 40;
    case "Approve-Reject":
      return 41;
    case "Reports":
      return 42;
    case "Investigation-Case":
      return 43;
    case "Auditor":
      return 45;
    case "Khatabat":
      return 51;
    case "NO_PERMISSION_NEEDED":
      return -999999;
    default:
      return 0;
  }
};

export const hasSpecificRoutePermission = (condition: "ALL_ADMINS") => {
  switch (condition) {
    case "ALL_ADMINS":
      const userPermissions = getCorePersonalStore().userPermissions.get();
      return userPermissions.indexOf(getPermissionIDRequired("Auditor")) > -1;
    default:
      break;
  }
  return false;
};

const hasPermission = (userPage: TCorePage) => {
  const userPermissions = getCorePersonalStore().userPermissions.get();
  const pagePermissions = getPagePermission(userPage);
  const permissionIDs = pagePermissions.map((permission) =>
    getPermissionIDRequired(permission)
  );
  const permissionGranted = permissionIDs.some((item) =>
    userPermissions.includes(item)
  );
  const hasPermission =
    permissionIDs.indexOf(-999999) > -1 ? true : permissionGranted;

  return hasPermission;
};
export default hasPermission;
